<template>
  <ReportsComponent
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import ReportsComponent from "@/own/components/reports/ReportComponent";

export default {
  name: "ReportSalesOrders",
  components: {
    ReportsComponent,
  },
  computed: {
    urls: () => ({
      data_url: "/reports/reportSalesOrders",
      show_url: "/reports/reportSalesOrders/show",
    }),
  },
};
</script>
